import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';
import { ExploreSort } from '../ducks/explore-nfts/explore-nfts.types';

interface ILocale {
    latest: string;
    oldest: string;
    priceHighLow: string;
    priceLowHigh: string;
    priceTechHighLow: string;
    priceTechLowHigh: string;
    nameTechAZ: string;
    nameTechZA: string;
    nameAZ: string;
    nameZA: string;
    quantityHighLow: string;
    quantityLowHigh: string;
}

export const useSortingOptions = () => {
    const { t } = useTranslation(['components']);
    const { isTechContemporary } = useGetUniverseTemplate();

    const locale: ILocale = useMemo(
        () => ({
            ...t('exploreFilter.actions.sorting.mode', { ns: 'components', returnObjects: true }),
        }),
        [t]
    );

    const memoizedData = useMemo(() => {
        if (isTechContemporary) {
            return [
                { value: ExploreSort.LATEST, label: 'Latest' },
                { value: ExploreSort.NAME_ASC, label: locale.nameTechAZ },
                { value: ExploreSort.NAME_DESC, label: locale.nameTechZA },
                { value: ExploreSort.PRICE_ASC, label: locale.priceTechLowHigh },
                { value: ExploreSort.PRICE_DESC, label: locale.priceTechHighLow },
            ];
        } 
            return [
                { value: ExploreSort.LATEST, label: locale.latest },
                { value: ExploreSort.OLDEST, label: locale.oldest },
                { value: ExploreSort.NAME_ASC, label: locale.nameAZ },
                { value: ExploreSort.NAME_DESC, label: locale.nameZA },
                { value: ExploreSort.PRICE_ASC, label: locale.priceLowHigh },
                { value: ExploreSort.PRICE_DESC, label: locale.priceHighLow },
                { value: ExploreSort.QUANTITY_ASC, label: locale.quantityLowHigh },
                { value: ExploreSort.QUANTITY_DESC, label: locale.quantityHighLow }
            ];
        
    }, [isTechContemporary, locale]);

    return memoizedData;
};
